import useSWR from 'swr'
import fetcher from '../../utils/fetcher'
import localSave from '../../utils/localSave'
import { ResponseData } from './types'

/**教育经历 */
export interface EducationDetailItem {
  userid: string
  sort: string
  school: string
  fromdate: string
  todate: string
  department: string
  major: string
  majorRanking: string
  degree: string
}

/**作品代表 */
export interface AwardInfoItem {
  userid: string
  sort: string
  name: string
  finisheddate: string
  type: string
  publishingOffice: string
  link: string
  file: string
}

/**实践（工作）经历 */
export interface PracticeExperienceItem {
  userid: string
  sort: string
  organizationName: string
  positionName: string
  fromdate: string
  todate: string
  experience: string
  // awards: string
}

/**学生工作 */
export interface StudentUnionItem {
  userid: string
  sort: string
  organizationName: string
  positionName: string
  fromdate: string
  todate: string
  workContent: string
}

/**意向城市 */
interface InterviewCityItem {
  id: string
  name: string
}

/**意向岗位 */
interface DeliverdJobItem {
  id: string
  name: string
  addtime: string
}


export interface ResumeResponse {
  [key: string]: string | {}
  educationDetailList: EducationDetailItem[]
  awardInfoList: AwardInfoItem[]
  practiceExperienceList:  PracticeExperienceItem[]
  studentUnionList: StudentUnionItem[]
  interviewCity: InterviewCityItem[]
  intendedJobs: string[]
  deliveredJobs: DeliverdJobItem[]
}

export default function useFetchResume<T>() {
  const res = useSWR<ResponseData<ResumeResponse & T>>('/content.php?a=resumeAndDelivery', fetcher.get)

  if(res.data && res.data.success) {
    localSave.set('avatar', res.data.data.headImg)
  }

  return res
}